module.exports = __webpack_public_path__ + "static/freetrial-562f5e1fa38fc93f1595b1305559349b.png";